// Mind2Magic CRM — Pipeline & Views Module
// Extracted from index.html Step 11.

import { STAGES, TYPE_LABELS, M2M_THRESHOLD } from './constants.js'
import { store } from './store.js'
import { parseLocalDate } from './utils/date.js'

let currentDashScope = 'turismo'

// ========== POPULATE SELECTS ==========
function populateSelects() {
    const { team } = store
    const opts = team.map(t => `<option value="${t.nombre}">${t.nombre}</option>`).join('')
    const optsWithOtro = '<option value="">Seleccionar...</option>' + opts + '<option value="__otro__">+ Agregar nuevo...</option>'
    document.getElementById('fResponsable').innerHTML = optsWithOtro
    document.getElementById('eResponsable').innerHTML = opts
    document.getElementById('filterResponsable').innerHTML = '<option value="">Todos</option>' + opts
    document.getElementById('eEtapa').innerHTML = STAGES.map(s => `<option value="${s.id}">${s.name}</option>`).join('')
    document.getElementById('badgeEquipo').textContent = team.length
}

function populateMonthFilter() {
    const { leads, historico } = store
    // Años de viaje (filtrando fechas inválidas como 1969)
    const years = new Set()
    const getYear = (date) => {
        if (!date) return null
        const d = new Date(date)
        if (isNaN(d) || d.getFullYear() < 2000) return null // Filtrar fechas inválidas
        return d.getFullYear().toString()
    }
    leads.forEach(l => { const y = getYear(l.travelDate); if (y) years.add(y) })
    historico.forEach(h => { const y = getYear(h.travelDate); if (y) years.add(y) })
    const sortedYears = Array.from(years).sort((a, b) => b - a) // Más reciente primero
    document.getElementById('filterYear').innerHTML = '<option value="">Todos</option>' + sortedYears.map(y => `<option value="${y}">${y}</option>`).join('')

    // Etapas con leads
    const stagesWithLeads = new Set()
    leads.forEach(l => { if (l.stage) stagesWithLeads.add(l.stage) })
    const etapaOptions = STAGES.filter(s => stagesWithLeads.has(s.id)).map(s => `<option value="${s.id}">${s.name}</option>`).join('')
    document.getElementById('filterEtapa').innerHTML = '<option value="">Todas</option>' + etapaOptions
}

function toggleOtroResp(sel, inputId) {
    const input = document.getElementById(inputId)
    if (sel.value === '__otro__') { input.classList.remove('hidden'); input.focus() }
    else input.classList.add('hidden')
}

// ========== BADGES ==========
function updateBadges() {
    const { leads, historico } = store
    // Agrupar todos los viajes FULLY PAID por cliente (leads + histórico)
    const clientTrips = {}

    leads.forEach(l => {
        const key = l.clientKey || ('name:' + (l.titular || '').toLowerCase())
        if (!clientTrips[key]) clientTrips[key] = { trips: [], m2mTotal: 0 }
        // Only count fully paid trips for frecuentes and M2M
        if (window.isFullyPaidTrip(l)) {
            clientTrips[key].trips.push({ travelDate: l.travelDate })
            clientTrips[key].m2mTotal += parseFloat(l.commission70) || 0
        }
    })

    historico.forEach(h => {
        const key = h.clientKey || ('name:' + (h.titular || '').toLowerCase())
        if (!clientTrips[key]) clientTrips[key] = { trips: [], m2mTotal: 0 }
        if (!h.wasCanceled) {
            clientTrips[key].trips.push({ travelDate: h.travelDate })
            clientTrips[key].m2mTotal += parseFloat(h.commission70) || 0
        }
    })

    // Contar frecuentes (only fully paid trips qualify)
    const freqCount = Object.values(clientTrips).filter(c => window.isFrequentFromAllTrips(c.trips)).length
    document.getElementById('badgeFrecuentes').textContent = freqCount

    // Contar M2M (only fully paid trips contribute to total)
    const m2mCount = Object.values(clientTrips).filter(c => c.m2mTotal >= M2M_THRESHOLD).length
    document.getElementById('badgeM2M').textContent = m2mCount

    document.getElementById('badgeProximos').textContent = leads.filter(window.isProximoAViajar).length

    // Actualizar badge calendario con eventos del mes actual
    try {
        if (typeof window.getCalendarEvents === 'function') {
            const now = new Date()
            const events = window.getCalendarEvents()
            const thisMonthEvents = events.filter(e => {
                const d = new Date(e.date)
                return d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth()
            })
            document.getElementById('badgeCalendario').textContent = thisMonthEvents.length
        }
    } catch(e) { /* ignore if calendar not ready */ }

    // Clients count
    const clientCount = Object.values(store.clients).filter(c => c.trips.some(t => t.stage !== 'historico')).length
    const badgeClients = document.getElementById('badgeClients')
    if (badgeClients) badgeClients.textContent = clientCount

    // Historico count
    const badgeHistorico = document.getElementById('badgeHistorico')
    if (badgeHistorico) badgeHistorico.textContent = store.historico.length

    // Watched count
    const PURCHASED_STAGES_W = ['reserva_abono', 'pago_completo', 'documentacion', 'en_destino', 'finalizado', 'postventa']
    const watchedCount = store.leads.filter(l => l.formData?.watched && !PURCHASED_STAGES_W.includes(l.stage) && l.stage !== 'cancelado' && l.stage !== 'no_compro').length
    const badgeWatched = document.getElementById('badgeWatched')
    if (badgeWatched) badgeWatched.textContent = watchedCount
}

// ========== PIPELINE ==========
function renderPipeline() {
    const { leads, historico, showHistorico, selectionMode } = store
    const filtered = getFilteredLeads()

    // Renderizar columnas normales
    let pipelineHTML = STAGES.map(s => {
        const stageLeads = filtered.filter(l => l.stage === s.id)
        const selectBtn = selectionMode && stageLeads.length ? `<button class="col-select-btn" onclick="event.stopPropagation(); selectColumn('${s.id}')" title="Seleccionar todos">☑</button>` : ''
        return `<div class="column" data-stage="${s.id}">
            <div class="col-header"><div class="col-title"><span class="col-dot" style="background:${s.color}"></span>${s.name}</div><div style="display:flex;align-items:center;gap:6px;">${selectBtn}<span class="col-count">${stageLeads.length}</span></div></div>
            <div class="col-cards" data-stage="${s.id}">${stageLeads.length ? stageLeads.map(renderCard).join('') : '<div class="col-empty">Sin leads</div>'}</div>
        </div>`
    }).join('')

    // Agregar columna Histórico si está activado
    if (showHistorico && historico.length > 0) {
        // Aplicar filtros al histórico también
        let filteredHistorico = [...historico]
        const filterTipo = document.getElementById('filterTipo')?.value
        const filterResp = document.getElementById('filterResponsable')?.value
        const filterYear = document.getElementById('filterYear')?.value

        if (filterTipo) filteredHistorico = filteredHistorico.filter(l => l.type === filterTipo)
        if (filterResp) filteredHistorico = filteredHistorico.filter(l => l.responsable === filterResp)
        if (filterYear) filteredHistorico = filteredHistorico.filter(l => l.travelDate && new Date(l.travelDate).getFullYear().toString() === filterYear)

        // Ordenar por fecha de viaje descendente
        filteredHistorico.sort((a, b) => new Date(b.travelDate) - new Date(a.travelDate))

        pipelineHTML += `<div class="column" data-stage="historico" style="border-color: #6366f1; background: linear-gradient(180deg, rgba(99,102,241,0.05) 0%, transparent 100%);">
            <div class="col-header"><div class="col-title"><span class="col-dot" style="background:#6366f1"></span>📦 Histórico</div><span class="col-count">${filteredHistorico.length}</span></div>
            <div class="col-cards" data-stage="historico">${filteredHistorico.length ? filteredHistorico.map(renderCard).join('') : '<div class="col-empty">Sin viajes históricos</div>'}</div>
        </div>`
    }

    document.getElementById('pipeline').innerHTML = pipelineHTML
    setupDragDrop()
    if (selectionMode) window.setupSelectionMode()
    // Restaurar leads zoom
    window.setLeadsZoom(window._currentLeadsZoom || 1)

}

// Card con 3 valores financieros
function renderCard(l) {
    const _supaId = l._supabaseId || l.id;
    const _waSummary = store.waLeadSummaries[_supaId];
    let waIndicator = '';
    let waBadge = '';
    if (_waSummary) {
        const _waHours = (Date.now() - new Date(_waSummary.lastMessageAt).getTime()) / 3600000;
        const _waPending = _waSummary.lastDirection === 'in';
        if (_waPending) {
            waIndicator = '<span title="Pendiente respuesta" style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#f59e0b;margin-right:4px;"></span>';
            waBadge = '<span style="font-size:9px;padding:1px 5px;border-radius:8px;background:rgba(245,158,11,0.2);color:#f59e0b;">Pendiente WA</span>';
        } else if (_waHours <= 24) {
            waIndicator = '<span title="WhatsApp activo" style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1FA855;margin-right:4px;"></span>';
        } else if (_waHours > (store.settings.alertaWhatsApp || 2) * 24) {
            waIndicator = '<span title="Conversación fría" style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#9ca3af;margin-right:4px;"></span>';
        } else {
            waIndicator = '<span title="WhatsApp activo" style="display:inline-block;width:8px;height:8px;border-radius:50%;background:#1FA855;margin-right:4px;"></span>';
        }
    }
    const waTimeLabel = _waSummary ? '<span style="font-size:9px;color:var(--text-3);margin-right:4px;">WA ' + (window.waTimeAgo?.(_waSummary.lastMessageAt) || '') + '</span>' : '';

    // abono = cuánto DEBE pagar de abono
    // abonado = cuánto YA pagó
    const abonoRequerido = l.abono || window.calcularAbonoEsperado(l.type, l.totalVenta)
    const abonado = l.abonado || 0
    const saldoPendiente = (l.totalVenta || 0) - abonado
    const abonoCompleto = abonado >= abonoRequerido
    const hoy = new Date()
    hoy.setHours(0, 0, 0, 0)

    // Determinar nivel de alerta para ABONO
    // > 7 días: normal | 7-3 días: atención | 2-1 días: urgente | 0: hoy | < 0: vencido
    let nivelAbono = 'normal'
    let diasParaAbono = null
    if (l.fechaAbono && !abonoCompleto) {
        const fechaAbono = new Date(l.fechaAbono)
        diasParaAbono = Math.ceil((fechaAbono - hoy) / (1000 * 60 * 60 * 24))
        if (diasParaAbono < 0) nivelAbono = 'vencido'
        else if (diasParaAbono === 0) nivelAbono = 'hoy'
        else if (diasParaAbono <= 2) nivelAbono = 'urgente'
        else if (diasParaAbono <= 7) nivelAbono = 'atencion'
    }

    // Determinar nivel de alerta para PAGO FINAL
    // > 30 días: normal | 30-16 días: atención | 15-1 días: urgente | 0: hoy | < 0: vencido
    let nivelPago = 'normal'
    let diasRestantes = null
    if (l.fechaPagoFinal && saldoPendiente > 0) {
        const fechaPago = parseLocalDate(l.fechaPagoFinal)
        diasRestantes = fechaPago ? Math.ceil((fechaPago - hoy) / (1000 * 60 * 60 * 24)) : null
        if (diasRestantes < 0) nivelPago = 'vencido'
        else if (diasRestantes === 0) nivelPago = 'hoy'
        else if (diasRestantes <= 15) nivelPago = 'urgente'
        else if (diasRestantes <= 30) nivelPago = 'atencion'
    }

    // Mostrar info de pago si está en etapas de pago o tiene valor de venta
    const mostrarPago = l.totalVenta > 0 && ['prereserva', 'reserva_abono', 'pago_completo', 'documentacion'].includes(l.stage)

    // Días para el viaje (leads confirmados con fecha futura)
    // Confirmed = has payment OR is in a paid stage (older Excel leads with "-" abono + commission)
    const CONFIRMED_STAGES = ['pago_completo', 'documentacion', 'en_destino', 'finalizado', 'postventa']
    const esConfirmado = abonado > 0 || CONFIRMED_STAGES.includes(l.stage) || (l.commission70 > 0 && l.stage !== 'cancelado' && l.stage !== 'no_califica' && l.stage !== 'no_compro')
    let diasParaViaje = null
    if (esConfirmado && l.travelDate) {
        const fechaViaje = parseLocalDate(l.travelDate)
        diasParaViaje = fechaViaje ? Math.ceil((fechaViaje - hoy) / (1000 * 60 * 60 * 24)) : null
    }

    // Determinar clase de alerta visual (el nivel más crítico gana)
    // Orden de prioridad: vencido > hoy > urgente > atencion > normal
    const niveles = { normal: 0, atencion: 1, urgente: 2, hoy: 3, vencido: 4 }
    const nivelMax = niveles[nivelAbono] > niveles[nivelPago] ? nivelAbono : nivelPago
    const diasMenor = Math.min(diasParaAbono ?? 999, diasRestantes ?? 999)

    let claseAlerta = ''
    let mensajeAlerta = ''
    if (l.stage !== 'historico') {
        if (nivelMax === 'vencido') claseAlerta = 'pago-vencido'
        else if (nivelMax === 'hoy') claseAlerta = 'pago-hoy'
        else if (nivelMax === 'urgente') claseAlerta = 'pago-urgente'
        else if (nivelMax === 'atencion') {
            claseAlerta = 'pago-atencion'
            mensajeAlerta = '📅 Pago en ' + diasMenor + 'd'
        }
    }

    return `<div class="card ${claseAlerta} ${l.stage === 'historico' ? 'historico' : ''}" draggable="${l.stage !== 'historico'}" data-id="${l.id}" onclick="openLead('${l.id}')" ${mensajeAlerta ? 'data-alert-msg="' + mensajeAlerta + '"' : ''}>
        <div class="card-top">
            <div><div class="card-name">${window.escHtml(l.titular) || 'Sin nombre'}</div>${l.contacto && l.contacto !== l.titular ? `<div class="card-contact">→ ${window.escHtml(l.contacto)}</div>` : ''}</div>
            <span class="card-tag ${l.type}">${TYPE_LABELS[l.type] || 'Otro'}</span>
        </div>
        <div class="card-info">
            <div class="card-row"><svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/></svg>${window.escHtml(l.destination) || 'Sin destino'}</div>
            <div class="card-row"><svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>${window.fmtDate(l.travelDate)}${diasParaViaje !== null && diasParaViaje > 0 ? ` <span style="font-size:10px;padding:1px 6px;border-radius:8px;background:${diasParaViaje <= 7 ? 'rgba(59,130,246,0.25)' : diasParaViaje <= 30 ? 'rgba(59,130,246,0.15)' : 'rgba(16,185,129,0.12)'};color:${diasParaViaje <= 30 ? '#3b82f6' : 'var(--green)'};font-weight:600;">✈️ ${diasParaViaje}d</span>` : diasParaViaje !== null && diasParaViaje === 0 ? ` <span style="font-size:10px;padding:1px 6px;border-radius:8px;background:rgba(59,130,246,0.3);color:#3b82f6;font-weight:600;">✈️ HOY</span>` : ''}</div>
            ${l.source === 'Formulario Web' && l.createdAt ? `<div class="card-row" style="color:var(--text-3);font-size:10px;">📝 Solicitud: ${window.fmtDate(l.createdAt)}</div>` : ''}
            ${window.fmtViajeros(l, 'card') ? `<div class="card-row"><svg fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>${window.escHtml(window.fmtViajeros(l, 'card'))}</div>` : ''}
        </div>
        <div class="card-financials">
            <div class="card-fin"><div class="card-fin-val green">${window.fmt(l.totalVenta)}</div><div class="card-fin-label">Venta</div></div>
            <div class="card-fin"><div class="card-fin-val">${window.fmt(l.commission)}</div><div class="card-fin-label">Comisión</div></div>
            <div class="card-fin"><div class="card-fin-val green">${window.fmt(l.commission70)}</div><div class="card-fin-label">M2M</div></div>
        </div>
        ${mostrarPago ? `<div class="card-payment">
            <div class="payment-row ${nivelAbono !== 'normal' ? 'urgent' : ''}">
                <span class="payment-label">💵 Abonado:</span>
                <span class="payment-val ${abonoCompleto ? 'paid' : 'pending'}">${abonado > 0 ? window.fmt(abonado) : 'Pendiente'} ${abonoRequerido > 0 ? `<small style="opacity:0.7">/ ${window.fmt(abonoRequerido)}</small>` : ''}${diasParaAbono !== null && !abonoCompleto ? ` <small>(${diasParaAbono}d)</small>` : ''}</span>
            </div>
            ${saldoPendiente > 0 ? `<div class="payment-row">
                <span class="payment-label">📋 Saldo:</span>
                <span class="payment-val pending">${window.fmt(saldoPendiente)}</span>
            </div>` : '<div class="payment-row"><span class="payment-label">✅ Pago:</span><span class="payment-val paid">Completo</span></div>'}
            ${l.fechaPagoFinal && saldoPendiente > 0 ? `<div class="payment-row ${nivelPago !== 'normal' ? 'urgent' : ''}">
                <span class="payment-label">⏰ Límite final:</span>
                <span class="payment-val">${window.fmtDate(l.fechaPagoFinal)}${diasRestantes !== null ? ` (${diasRestantes}d)` : ''}</span>
            </div>` : ''}
        </div>` : ''}
        <div class="card-footer">
            <div class="card-progress"><div class="progress-bar"><div class="progress-fill" style="width:${l.progress || 0}%"></div></div><span class="progress-pct">${l.progress || 0}%</span></div>
            <div class="card-badges">${waIndicator}${waTimeLabel}${waBadge}${l.cotizacionRevisions > 0 ? `<span style="font-size:9px;padding:1px 5px;border-radius:8px;background:rgba(234,88,12,0.2);color:#ea580c;">🔄 ${l.cotizacionRevisions}</span>` : ''}${l._guideSession ? `<span style="font-size:9px;padding:1px 5px;border-radius:8px;background:${l._guideSession.status === 'completed' ? 'rgba(16,185,129,0.2)' : l._guideSession.status === 'in_progress' ? 'rgba(245,158,11,0.2)' : 'rgba(255,255,255,0.1)'};color:${l._guideSession.status === 'completed' ? 'var(--green)' : l._guideSession.status === 'in_progress' ? '#f59e0b' : 'var(--text-3)'};">Itin. ${{pending:'⏳',viewed:'👁️',in_progress:'✏️',completed:'✅'}[l._guideSession.status] || ''}</span>` : ''}${l.seguimientos > 0 ? `<span class="seguimiento-badge">${l.seguimientos} seg.</span>` : ''}${l.responsable ? `<span class="badge resp">${l.responsable}</span>` : ''}</div>
        </div>
    </div>`
}

function getFilteredLeads() {
    const { leads } = store
    let f = [...leads]
    const tipo = document.getElementById('filterTipo')?.value
    const resp = document.getElementById('filterResponsable')?.value
    const mes = document.getElementById('filterMes')?.value
    const year = document.getElementById('filterYear')?.value
    const etapa = document.getElementById('filterEtapa')?.value
    const periodo = document.getElementById('filterPeriodo')?.value
    const sort = document.getElementById('filterSort')?.value || 'nombre_asc'

    if (tipo) f = f.filter(l => l.type === tipo)
    if (resp) f = f.filter(l => l.responsable === resp)

    // Filtrar por mes (01-12)
    if (mes) {
        f = f.filter(l => {
            if (!l.travelDate) return false
            const d = new Date(l.travelDate)
            if (isNaN(d)) return false
            return String(d.getMonth() + 1).padStart(2, '0') === mes
        })
    }

    // Filtrar por año
    if (year) {
        f = f.filter(l => {
            if (!l.travelDate) return false
            const d = new Date(l.travelDate)
            if (isNaN(d)) return false
            return d.getFullYear().toString() === year
        })
    }

    // Filtrar por período (próximos X meses)
    if (periodo) {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        const months = parseInt(periodo)
        const futureDate = new Date(today)
        futureDate.setMonth(futureDate.getMonth() + months)

        f = f.filter(l => {
            if (!l.travelDate) return false
            const d = new Date(l.travelDate)
            if (isNaN(d)) return false
            return d >= today && d <= futureDate
        })
    }

    if (etapa) f = f.filter(l => l.stage === etapa)

    const waFilter = document.getElementById('filterWhatsApp')?.value;
    if (waFilter) {
        f = f.filter(l => {
            const ws = store.waLeadSummaries[l._supabaseId || l.id];
            switch (waFilter) {
                case 'pendiente': return ws && ws.lastDirection === 'in';
                case 'fria': return ws && (Date.now() - new Date(ws.lastMessageAt).getTime()) > (store.settings.alertaWhatsApp || 2) * 24 * 3600000;
                case 'con_wa': return !!ws;
                case 'sin_wa': return !ws;
                default: return true;
            }
        });
    }

    f.sort((a, b) => {
        switch (sort) {
            case 'nombre_asc': return (a.titular || '').localeCompare(b.titular || '')
            case 'nombre_desc': return (b.titular || '').localeCompare(a.titular || '')
            case 'fecha_viaje_asc': return new Date(a.travelDate || 0) - new Date(b.travelDate || 0)
            case 'fecha_viaje_desc': return new Date(b.travelDate || 0) - new Date(a.travelDate || 0)
            case 'registro_desc': return new Date(b.createdAt || 0) - new Date(a.createdAt || 0)
            case 'registro_asc': return new Date(a.createdAt || 0) - new Date(b.createdAt || 0)
            case 'valor_asc': return (a.totalVenta || 0) - (b.totalVenta || 0)
            case 'valor_desc': return (b.totalVenta || 0) - (a.totalVenta || 0)
            case 'comm_asc': return (a.commission || 0) - (b.commission || 0)
            case 'comm_desc': return (b.commission || 0) - (a.commission || 0)
            case 'm2m_asc': return (a.commission70 || 0) - (b.commission70 || 0)
            case 'm2m_desc': return (b.commission70 || 0) - (a.commission70 || 0)
            case 'pago_abono_asc': {
                // Ordenar por fecha límite de abono más próxima
                // SOLO prioriza los que están en Pre-Reserva (no han pagado abono)
                const abonoReqA = a.abono || window.calcularAbonoEsperado(a.type, a.totalVenta)
                const abonoReqB = b.abono || window.calcularAbonoEsperado(b.type, b.totalVenta)
                const aPendienteAbono = (a.abonado || 0) < abonoReqA && a.stage === 'prereserva'
                const bPendienteAbono = (b.abonado || 0) < abonoReqB && b.stage === 'prereserva'

                // Los que tienen abono pendiente van primero
                if (aPendienteAbono && !bPendienteAbono) return -1
                if (!aPendienteAbono && bPendienteAbono) return 1

                // Entre los pendientes, ordenar por fecha más próxima
                if (aPendienteAbono && bPendienteAbono) {
                    const fechaA = a.fechaAbono ? new Date(a.fechaAbono) : new Date('2099-12-31')
                    const fechaB = b.fechaAbono ? new Date(b.fechaAbono) : new Date('2099-12-31')
                    return fechaA - fechaB
                }

                // Los demás mantienen orden por nombre
                return (a.titular || '').localeCompare(b.titular || '')
            }
            case 'pago_final_asc': {
                // Ordenar por fecha límite de pago final más próxima
                // SOLO prioriza los que están en Reserva con Abono (ya pagaron abono, falta saldo)
                const saldoA = (a.totalVenta || 0) - (a.abonado || 0)
                const saldoB = (b.totalVenta || 0) - (b.abonado || 0)
                const aPendienteFinal = saldoA > 0 && a.stage === 'reserva_abono'
                const bPendienteFinal = saldoB > 0 && b.stage === 'reserva_abono'

                // Los que tienen pago final pendiente van primero
                if (aPendienteFinal && !bPendienteFinal) return -1
                if (!aPendienteFinal && bPendienteFinal) return 1

                // Entre los pendientes, ordenar por fecha más próxima
                if (aPendienteFinal && bPendienteFinal) {
                    const fechaA = a.fechaPagoFinal ? new Date(a.fechaPagoFinal) : new Date('2099-12-31')
                    const fechaB = b.fechaPagoFinal ? new Date(b.fechaPagoFinal) : new Date('2099-12-31')
                    return fechaA - fechaB
                }

                // Los demás mantienen orden por nombre
                return (a.titular || '').localeCompare(b.titular || '')
            }
            default: return 0
        }
    })
    return f
}

function applyFilters() { renderPipeline(); updateStats(); if (window.updateMobileFiltersBadge) window.updateMobileFiltersBadge(); }

function resetFilters() {
    document.getElementById('filterSort').value = 'nombre_asc'
    document.getElementById('filterTipo').value = ''
    document.getElementById('filterResponsable').value = ''
    document.getElementById('filterMes').value = ''
    document.getElementById('filterYear').value = ''
    document.getElementById('filterEtapa').value = ''
    document.getElementById('filterPeriodo').value = ''
    const waEl = document.getElementById('filterWhatsApp');
    if (waEl) waEl.value = '';
    document.getElementById('includeHistorico').checked = false
    store.showHistorico = false
    applyFilters()
    window.toast('Filtros restablecidos', 'success')
}

function toggleHistorico() {
    store.showHistorico = document.getElementById('includeHistorico').checked
    window.renderAll()
    if (store.showHistorico) {
        window.toast(`📦 Mostrando ${store.historico.length} viajes históricos`, 'success')
    }
}

function toggleModoCompleto() {
    store.modoCompleto = document.getElementById('modoCompletoCheck').checked
    // Si hay un lead abierto, refrescar el panel
    if (store.currentLeadId) {
        window.openLead(store.currentLeadId)
    }
    window.toast(store.modoCompleto ? '📋 Vista completa activada' : '📋 Vista compacta activada', 'success')
}

function togglePanelDetails() {
    const details = document.getElementById('panelDetailsExpanded')
    const icon = document.getElementById('toggleDetailsIcon')
    const btn = document.getElementById('btnToggleDetails')
    if (!details || !icon || !btn) return

    if (details.style.display === 'none') {
        details.style.display = 'block'
        icon.textContent = '▲'
        btn.innerHTML = '<span id="toggleDetailsIcon">▲</span> Ocultar detalles'
    } else {
        details.style.display = 'none'
        icon.textContent = '▼'
        btn.innerHTML = '<span id="toggleDetailsIcon">▼</span> Ver más detalles'
    }
}

// toggleOcultarValores — extracted to src/settings.js (Step 8)

// Sincronizar fecha fin con fecha inicio (no puede ser anterior)
function syncEndDate(startId, endId) {
    const startInput = document.getElementById(startId)
    const endInput = document.getElementById(endId)

    if (startInput.value) {
        // Establecer el mínimo de fecha fin = fecha inicio
        endInput.min = startInput.value

        // Si fecha fin está vacía o es anterior a fecha inicio, actualizarla
        if (!endInput.value || endInput.value < startInput.value) {
            endInput.value = startInput.value
        }

        // Enfocar fecha fin para que el usuario pueda seleccionar
        endInput.focus()
    }
}

// Calcular abono según tipo de viaje
// Disney: $200, Universal: $150, Crucero: 10% del total, Hotel: 20% del total, Otro: $100
function calcularAbono(prefix) {
    const tipo = document.getElementById(prefix + 'Tipo').value
    const valorVenta = parseFloat(document.getElementById(prefix + 'Costo').value) || 0
    const abonoInput = document.getElementById(prefix + 'Abono')

    // Solo auto-llenar si el campo está vacío o es 0
    if (abonoInput.value && parseFloat(abonoInput.value) > 0) return

    let abono = 0
    switch (tipo) {
        case 'disney': abono = 200; break
        case 'universal': abono = 150; break
        case 'disney_universal': abono = 200; break
        case 'crucero': abono = Math.round(valorVenta * 0.10); break
        case 'parques_crucero': abono = Math.max(200, Math.round(valorVenta * 0.10)); break
        case 'hotel': abono = Math.round(valorVenta * 0.20); break
        case 'evento': abono = 100; break
        default: abono = 100; break
    }

    if (abono > 0) {
        abonoInput.value = abono
    }
}

// ========== STATS REACTIVOS (cambian con filtros) ==========
function updateStats() {
    const { leads, historico, showHistorico } = store
    const filtered = getFilteredLeads()

    // Si se muestra histórico, agregar a los stats
    let allForStats = [...filtered]
    if (showHistorico && historico.length > 0) {
        let filteredHistorico = [...historico]
        const filterTipo = document.getElementById('filterTipo')?.value
        const filterResp = document.getElementById('filterResponsable')?.value
        const filterYear = document.getElementById('filterYear')?.value

        if (filterTipo) filteredHistorico = filteredHistorico.filter(l => l.type === filterTipo)
        if (filterResp) filteredHistorico = filteredHistorico.filter(l => l.responsable === filterResp)
        if (filterYear) filteredHistorico = filteredHistorico.filter(l => l.travelDate && new Date(l.travelDate).getFullYear().toString() === filterYear)

        allForStats = [...filtered, ...filteredHistorico]
    }

    const countLabel = showHistorico ? 'Leads + Histórico' : 'Leads'
    document.getElementById('statLeads').textContent = allForStats.length
    const statLeadsEl = document.getElementById('statLeads')
    if (statLeadsEl?.parentElement) { const lbl = statLeadsEl.parentElement.querySelector('.stat-label'); if (lbl) lbl.textContent = countLabel }
    const activeForFinancials = allForStats.filter(l => l.stage !== 'cancelado' && l.stage !== 'no_califica' && l.stage !== 'no_compro' && !l.wasCanceled)
    document.getElementById('statValue').textContent = window.fmt(activeForFinancials.reduce((s, l) => s + (l.totalVenta || 0), 0))
    document.getElementById('statComm').textContent = window.fmt(activeForFinancials.reduce((s, l) => s + (l.commission || 0), 0))
    document.getElementById('statCommM2M').textContent = window.fmt(activeForFinancials.reduce((s, l) => s + (l.commission70 || 0), 0))

    // Calcular y mostrar rango de fechas del Pipeline
    const datesInPipeline = allForStats.filter(l => l.travelDate).map(l => new Date(l.travelDate)).filter(d => !isNaN(d) && d.getFullYear() >= 2020)
    const pipelineRangeEl = document.getElementById('pipelineDateRange')
    if (pipelineRangeEl) {
        if (datesInPipeline.length > 0) {
            const minDate = new Date(Math.min(...datesInPipeline))
            const maxDate = new Date(Math.max(...datesInPipeline))
            const months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']
            const formatShort = d => `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`
            pipelineRangeEl.textContent = `📅 Viajes del ${formatShort(minDate)} al ${formatShort(maxDate)}`
        } else {
            pipelineRangeEl.textContent = ''
        }
    }
}

let _dragScrollRAF = null
function _startDragAutoScroll() {
    const wrapper = document.getElementById('pipelineWrapper') || document.getElementById('empPipelineWrapper')
    if (!wrapper) return
    let mouseX = 0
    const EDGE = 80, SPEED = 12
    const onDragOver = (e) => { mouseX = e.clientX }
    wrapper.addEventListener('dragover', onDragOver)
    const tick = () => {
        const rect = wrapper.getBoundingClientRect()
        if (mouseX > 0 && mouseX < rect.left + EDGE) wrapper.scrollLeft -= SPEED
        else if (mouseX > rect.right - EDGE) wrapper.scrollLeft += SPEED
        _dragScrollRAF = requestAnimationFrame(tick)
    }
    _dragScrollRAF = requestAnimationFrame(tick)
    return () => {
        wrapper.removeEventListener('dragover', onDragOver)
        if (_dragScrollRAF) { cancelAnimationFrame(_dragScrollRAF); _dragScrollRAF = null }
    }
}

function setupDragDrop() {
    const { leads, clients } = store
    let _stopAutoScroll = null
    document.querySelectorAll('.card').forEach(card => {
        card.ondragstart = e => { card.classList.add('dragging'); e.dataTransfer.setData('text', card.dataset.id); _stopAutoScroll = _startDragAutoScroll() }
        card.ondragend = () => { card.classList.remove('dragging'); document.querySelectorAll('.column').forEach(c => c.classList.remove('drag-over')); if (_stopAutoScroll) { _stopAutoScroll(); _stopAutoScroll = null } }
    })
    document.querySelectorAll('.column').forEach(col => {
        col.ondragover = e => { e.preventDefault(); col.classList.add('drag-over') }
        col.ondragleave = () => col.classList.remove('drag-over')
        col.ondrop = e => {
            e.preventDefault(); col.classList.remove('drag-over')
            const id = e.dataTransfer.getData('text'), stage = col.dataset.stage
            const lead = leads.find(l => l.id === id)
            if (lead && lead.stage !== stage) {
                window.saveState('mover lead')
                const _prevStage = lead.stage
                // Track cotización revision rounds (client requested changes)
                if (_prevStage === 'cotizacion' && stage === 'revision_cotizacion') {
                    lead.cotizacionRevisions = (lead.cotizacionRevisions || 0) + 1
                }
                lead.stage = stage; lead.progress = window.calcProgress(stage)
                window.addHistorial(lead, 'etapa', `Movido de ${STAGES.find(s => s.id === _prevStage)?.name || _prevStage} a ${STAGES.find(s => s.id === stage)?.name || stage}`, { stage: { antes: _prevStage, despues: stage } })
                const c = clients[lead.clientKey]; if (c) { const t = c.trips.find(t => t.id === id); if (t) { t.stage = stage; t.progress = lead.progress } }
                window.syncLeadToSupabase(lead)
                renderPipeline(); updateStats()
                window.toast(`Movido a "${STAGES.find(s => s.id === stage)?.name || stage}"`, 'success')
            }
        }
    })
}

// ========== SEARCH GLOBAL REACTIVO ==========
const _stripAccents = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()

function handleSearch(q) {
    const { leads } = store
    const query = _stripAccents(q.trim())
    const currentView = document.querySelector('.view.active')?.id

    if (currentView === 'pipelineView') {
        let firstVisibleCard = null
        document.querySelectorAll('.card').forEach(card => {
            const l = leads.find(l => l.id === card.dataset.id)
            const match = !query || (l && (_stripAccents(l.titular || '').includes(query) || _stripAccents(l.contacto || '').includes(query) || (l.phone || '').includes(query) || _stripAccents(l.destination || '').includes(query)))
            card.style.display = match ? 'block' : 'none'
            if (match && !firstVisibleCard) firstVisibleCard = card
        })
        // Auto-scroll pipeline to the first column with a visible match
        if (query && firstVisibleCard) {
            const col = firstVisibleCard.closest('.column')
            if (col) col.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' })
        }
    } else if (currentView === 'calendarioView') {
        // Filtrar eventos del calendario por búsqueda
        store.calendarSearchQuery = query
        window.renderCalendario()
    } else if (currentView === 'clientsView' || currentView === 'frecuentesView' || currentView === 'm2mView' || currentView === 'historicoView' || currentView === 'proximosView') {
        document.querySelectorAll('.client-card').forEach(card => {
            const text = _stripAccents(card.textContent)
            card.style.display = !query || text.includes(query) ? 'block' : 'none'
        })
    }
}
// ========== CLIENTS ==========
function renderClients() {
    const { leads, clients } = store
    const grid = document.getElementById('clientsGrid')
    const list = Object.entries(clients).map(([key, c]) => ({ key, ...c, isFrequent: window.isFrequentTraveler(c), isM2M: window.isM2MTraveler(c) })).filter(c => c.trips.some(t => t.stage !== 'historico')).sort((a, b) => a.titular.localeCompare(b.titular))
    if (!list.length) { grid.innerHTML = '<p style="color:var(--text-3);text-align:center;padding:40px;">No hay clientes.</p>'; return }
    grid.innerHTML = list.map(c => {
        const activeTrips = c.trips.filter(t => t.stage !== 'historico')
        const totalVal = activeTrips.reduce((s, t) => s + (t.totalVenta || 0), 0)
        const totalComm = activeTrips.reduce((s, t) => s + (t.commission || 0), 0)
        const totalM2M = activeTrips.reduce((s, t) => s + (t.commission70 || 0), 0)
        const esc = window.escHtml
        return `<div class="client-card ${c.isFrequent ? 'freq-card' : ''} ${c.isM2M ? 'm2m-card' : ''}" onclick="openClient('${esc(c.key)}')">
            <div class="client-header">
                <div class="client-avatar">${(c.titular || '?').charAt(0)}</div>
                <div class="client-info">
                    <div class="client-name">${esc(c.titular)} ${c.isFrequent ? '<span class="freq-badge">⭐ Frecuente</span>' : ''} ${c.isM2M ? '<span class="m2m-badge">💰 M2M</span>' : ''}</div>
                    <div class="client-phone">${esc(c.phone || c.email || 'Sin contacto')}</div>
                </div>
            </div>
            <div class="client-trips">
                <div class="trips-title">${activeTrips.length} viajes — Venta: ${window.fmt(totalVal)} | Com: ${window.fmt(totalComm)} | M2M: ${window.fmt(totalM2M)}</div>
                ${activeTrips.slice(0, 3).map(t => `<div class="trip-row"><span class="trip-dest">${esc(t.destination)}</span><span>${window.fmtDate(t.travelDate)}</span><span class="trip-val">${window.fmt(t.totalVenta)}</span></div>`).join('')}
                ${activeTrips.length > 3 ? `<div style="font-size:10px;color:var(--text-3);margin-top:4px;">+${activeTrips.length - 3} más</div>` : ''}
            </div>
        </div>`
    }).join('')
}

// ========== FRECUENTES ==========
function renderFrecuentes() {
    const { leads, historico } = store
    const grid = document.getElementById('frecuentesGrid')

    // Agrupar todos los viajes FULLY PAID por cliente (leads + histórico)
    const clientTrips = {}

    // Desde leads activos — only fully paid (pago_completo or later)
    leads.forEach(l => {
        const key = l.clientKey || ('name:' + (l.titular || '').toLowerCase())
        if (!clientTrips[key]) clientTrips[key] = { titular: l.titular, contacto: l.contacto, phone: l.phone, email: l.email, trips: [] }
        if (window.isFullyPaidTrip(l)) clientTrips[key].trips.push({ destination: l.destination, travelDate: l.travelDate, commission70: l.commission70, totalVenta: l.totalVenta, type: l.type })
    })

    // Desde histórico (wasCanceled excluded — isHistorico=true qualifies as fully paid)
    historico.forEach(h => {
        if (h.wasCanceled) return
        const key = h.clientKey || ('name:' + (h.titular || '').toLowerCase())
        if (!clientTrips[key]) clientTrips[key] = { titular: h.titular, contacto: h.contacto, phone: null, email: null, trips: [] }
        clientTrips[key].trips.push({ destination: h.destination, travelDate: h.travelDate, commission70: h.commission70, totalVenta: h.totalVenta, type: h.type })
    })

    // Filtrar frecuentes (2+ viajes separados >30 días)
    const frequent = Object.entries(clientTrips).map(([key, c]) => ({ key, ...c })).filter(c => window.isFrequentFromAllTrips(c.trips)).sort((a, b) => b.trips.length - a.trips.length)

    if (!frequent.length) { grid.innerHTML = '<p style="color:var(--text-3);text-align:center;padding:40px;">No hay viajeros frecuentes.</p>'; return }
    grid.innerHTML = frequent.map(c => {
        const totalVal = c.trips.reduce((s, t) => s + (parseFloat(t.totalVenta) || 0), 0)
        const totalM2M = c.trips.reduce((s, t) => s + (parseFloat(t.commission70) || 0), 0)
        const esc = window.escHtml
        return `<div class="client-card freq-card" onclick="openClient('${esc(c.key)}')">
            <div class="client-header">
                <div class="client-avatar">${(c.titular || '?').charAt(0)}</div>
                <div class="client-info">
                    <div class="client-name">${esc(c.titular)} <span class="freq-badge">⭐ ${c.trips.length} viajes</span></div>
                    ${c.contacto && c.contacto !== c.titular ? `<div style="font-size:11px;color:var(--text-2);">→ ${esc(c.contacto)}</div>` : ''}
                    <div class="client-phone">${esc(c.phone || c.email || 'Sin contacto')}</div>
                </div>
            </div>
            <div class="client-trips">
                <div class="trips-title">Venta: ${window.fmt(totalVal)} | M2M: ${window.fmt(totalM2M)}</div>
                ${c.trips.slice(0, 4).map(t => `<div class="trip-row"><span class="trip-dest">${esc(t.destination)}</span><span>${window.fmtDate(t.travelDate)}</span></div>`).join('')}
            </div>
        </div>`
    }).join('')
}

// ========== M2M (comisión > $700) ==========
function renderM2M() {
    const { leads, historico } = store
    const grid = document.getElementById('m2mGrid')

    // Calcular M2M por cliente usando leads + histórico — only fully paid trips
    const clientM2M = {}

    // Sumar desde leads activos — only fully paid (pago_completo or later)
    leads.forEach(l => {
        if (!window.isFullyPaidTrip(l)) return
        const key = l.clientKey || ('name:' + (l.titular || '').toLowerCase())
        if (!clientM2M[key]) clientM2M[key] = { titular: l.titular, contacto: l.contacto, phone: l.phone, email: l.email, trips: [], m2mTotal: 0 }
        clientM2M[key].m2mTotal += parseFloat(l.commission70) || 0
        clientM2M[key].trips.push({ destination: l.destination, travelDate: l.travelDate, commission70: l.commission70, totalVenta: l.totalVenta, commission: l.commission, type: l.type })
    })

    // Sumar desde histórico (wasCanceled excluded — isHistorico=true qualifies as fully paid)
    historico.forEach(h => {
        if (h.wasCanceled) return
        const key = h.clientKey || ('name:' + (h.titular || '').toLowerCase())
        if (!clientM2M[key]) clientM2M[key] = { titular: h.titular, contacto: h.contacto, phone: null, email: null, trips: [], m2mTotal: 0 }
        clientM2M[key].m2mTotal += parseFloat(h.commission70) || 0
        clientM2M[key].trips.push({ destination: h.destination, travelDate: h.travelDate, commission70: h.commission70, totalVenta: h.totalVenta, commission: h.commission, type: h.type })
    })

    const m2mClients = Object.entries(clientM2M).map(([key, c]) => ({ key, ...c })).filter(c => c.m2mTotal >= M2M_THRESHOLD).sort((a, b) => b.m2mTotal - a.m2mTotal)

    if (!m2mClients.length) { grid.innerHTML = '<p style="color:var(--text-3);text-align:center;padding:40px;">No hay viajeros M2M (>$700).</p>'; return }
    grid.innerHTML = m2mClients.map(c => {
        const totalVal = c.trips.reduce((s, t) => s + (parseFloat(t.totalVenta) || 0), 0)
        const totalComm = c.trips.reduce((s, t) => s + (parseFloat(t.commission) || 0), 0)
        const esc = window.escHtml
        return `<div class="client-card m2m-card" onclick="openClient('${esc(c.key)}')">
            <div class="client-header">
                <div class="client-avatar">${(c.titular || '?').charAt(0)}</div>
                <div class="client-info">
                    <div class="client-name">${esc(c.titular)} <span class="m2m-badge">💰 ${window.fmt(c.m2mTotal)}</span></div>
                    ${c.contacto && c.contacto !== c.titular ? `<div style="font-size:11px;color:var(--text-2);">→ ${esc(c.contacto)}</div>` : ''}
                    <div class="client-phone">${esc(c.phone || c.email || 'Sin contacto')}</div>
                </div>
            </div>
            <div class="client-trips">
                <div class="trips-title">${c.trips.length} viajes — Venta: ${window.fmt(totalVal)} | Com: ${window.fmt(totalComm)}</div>
                ${c.trips.slice(0, 3).map(t => `<div class="trip-row"><span class="trip-dest">${esc(t.destination)}</span><span>${window.fmtDate(t.travelDate)}</span><span class="trip-val">${window.fmt(t.commission70)}</span></div>`).join('')}
                ${c.trips.length > 3 ? `<div style="font-size:10px;color:var(--text-3);margin-top:4px;">+${c.trips.length - 3} más</div>` : ''}
            </div>
        </div>`
    }).join('')
}

// ========== PROXIMOS A VIAJAR (21 días) ==========
function renderProximos() {
    const { leads } = store
    const grid = document.getElementById('proximosGrid')
    const proximos = leads.filter(window.isProximoAViajar).sort((a, b) => new Date(a.travelDate) - new Date(b.travelDate))
    if (!proximos.length) { grid.innerHTML = '<p style="color:var(--text-3);text-align:center;padding:40px;">No hay viajes próximos (21 días).</p>'; return }
    const esc = window.escHtml
    grid.innerHTML = proximos.map(l => {
        const days = window.daysBetween(window.TODAY, window.parseLocalDate(l.travelDate) || new Date(l.travelDate))
        return `<div class="client-card" onclick="openLead('${esc(l.id)}')">
            <div class="client-header">
                <div class="client-avatar">${(l.titular || '?').charAt(0)}</div>
                <div class="client-info">
                    <div class="client-name">${esc(l.titular)} <span class="badge" style="background:var(--cyan);color:white;">En ${days} días</span></div>
                    ${l.contacto && l.contacto !== l.titular ? `<div style="font-size:11px;color:var(--text-2);">→ ${esc(l.contacto)}</div>` : ''}
                    <div class="client-phone">${esc(l.destination)} — ${window.fmtDate(l.travelDate)}</div>
                </div>
            </div>
            <div class="client-trips">
                <div class="trips-title">Venta: ${window.fmt(l.totalVenta)} | Com: ${window.fmt(l.commission)} | M2M: ${window.fmt(l.commission70)}</div>
                <div class="trip-row"><span>Responsable</span><span>${esc(l.responsable || 'Sin asignar')}</span></div>
                <div class="trip-row"><span>Etapa</span><span>${STAGES.find(s => s.id === l.stage)?.name || l.stage}</span></div>
            </div>
        </div>`
    }).join('')
}

// ========== HISTORICO (agrupado por cliente) ==========
function renderHistorico() {
    const { historico } = store
    const grid = document.getElementById('historicoGrid')
    // Agrupar por cliente
    const byClient = {}
    historico.forEach(h => {
        if (!byClient[h.clientKey]) byClient[h.clientKey] = { titular: h.titular, contacto: h.contacto, trips: [] }
        byClient[h.clientKey].trips.push(h)
    })
    const clientList = Object.entries(byClient).map(([key, data]) => ({
        key, ...data,
        totalVenta: data.trips.reduce((s, t) => s + (t.totalVenta || 0), 0),
        totalComm: data.trips.reduce((s, t) => s + (t.commission || 0), 0),
        totalM2M: data.trips.reduce((s, t) => s + (t.commission70 || 0), 0)
    })).sort((a, b) => b.totalM2M - a.totalM2M)

    if (!clientList.length) { grid.innerHTML = '<p style="color:var(--text-3);text-align:center;padding:40px;">No hay histórico.</p>'; return }
    const esc = window.escHtml
    grid.innerHTML = clientList.map(c => {
        const isLost = c.trips.every(t => t.stage === 'perdido')
        const lostReason = isLost && c.trips[0]?.lostReason ? c.trips[0].lostReason : null
        return `<div class="client-card${isLost ? ' m2m-card' : ''}" onclick="openClient('${esc(c.key)}')">
        <div class="client-header">
            <div class="client-avatar">${(c.titular || '?').charAt(0)}</div>
            <div class="client-info">
                <div class="client-name">${esc(c.titular)} ${isLost ? `<span class="m2m-badge">Perdido</span>` : `<span class="badge">${c.trips.length} viajes</span>`}</div>
                ${c.contacto && c.contacto !== c.titular ? `<div style="font-size:11px;color:var(--text-2);">→ ${esc(c.contacto)}</div>` : ''}
                <div class="client-phone">${isLost ? esc(lostReason || 'Lead perdido') : 'Histórico (>6 meses)'}</div>
            </div>
        </div>
        <div class="client-trips">
            <div class="trips-title">Venta: ${window.fmt(c.totalVenta)} | Com: ${window.fmt(c.totalComm)} | M2M: ${window.fmt(c.totalM2M)}</div>
            ${c.trips.slice(0, 3).map(t => `<div class="trip-row"><span class="trip-dest">${esc(t.destination)}</span><span>${window.fmtDate(t.travelDate)}</span><span class="trip-val">${window.fmt(t.totalVenta)}</span></div>`).join('')}
            ${c.trips.length > 3 ? `<div style="font-size:10px;color:var(--text-3);margin-top:4px;">+${c.trips.length - 3} más</div>` : ''}
        </div>
    </div>`
    }).join('')
}

// ========== SEGUIMIENTO (watched leads) ==========
function renderWatched() {
    const { leads } = store
    const grid = document.getElementById('watchedGrid')
    if (!grid) return
    const PURCHASED_STAGES = ['reserva_abono', 'pago_completo', 'documentacion', 'en_destino', 'finalizado', 'postventa']
    const watched = leads.filter(l => l.formData?.watched && !PURCHASED_STAGES.includes(l.stage) && l.stage !== 'cancelado' && l.stage !== 'no_compro')
        .sort((a, b) => {
            const stageOrder = { 'nuevo': 0, 'formulario': 1, 'no_califica': 2, 'asesoria_solicitada': 3, 'asesoria_agendada': 4, 'asesoria_realizada': 5, 'proximo_ano': 6, 'cotizacion_solicitada': 7, 'cotizacion': 8, 'revision_cotizacion': 9, 'prereserva': 10, 'no_compro': 11 }
            return (stageOrder[a.stage] ?? 99) - (stageOrder[b.stage] ?? 99)
        })
    if (!watched.length) { grid.innerHTML = '<p style="color:var(--text-3);text-align:center;padding:40px;">No hay leads en seguimiento.</p>'; return }
    const esc = window.escHtml
    grid.innerHTML = watched.map(l => {
        const stageName = STAGES.find(s => s.id === l.stage)?.name || l.stage
        const stageColor = STAGES.find(s => s.id === l.stage)?.color || '#888'
        return `<div class="client-card" onclick="openLead('${esc(l.id)}')" style="border-left:3px solid ${stageColor};">
            <div class="client-header">
                <div class="client-avatar">${(l.titular || '?').charAt(0)}</div>
                <div class="client-info">
                    <div class="client-name">${esc(l.titular)} <span class="badge" style="background:${stageColor};color:white;font-size:9px;">${stageName}</span></div>
                    ${l.contacto && l.contacto !== l.titular ? '<div style="font-size:11px;color:var(--text-2);">' + esc(l.contacto) + '</div>' : ''}
                    <div class="client-phone">${esc(l.destination || 'Sin destino')} ${l.travelDate ? ' — ' + window.fmtDate(l.travelDate) : ''}</div>
                </div>
            </div>
            <div class="client-trips">
                <div class="trips-title">Venta: ${window.fmt(l.totalVenta)} | Com: ${window.fmt(l.commission)} | M2M: ${window.fmt(l.commission70)}</div>
                <div class="trip-row"><span>Responsable</span><span>${esc(l.responsable || 'Sin asignar')}</span></div>
            </div>
        </div>`
    }).join('')
}

// ========== TEAM ==========
function renderTeam() {
    const { leads, team } = store
    const grid = document.getElementById('teamGrid')
    grid.innerHTML = team.map((t, i) => {
        const leadsCount = leads.filter(l => l.responsable === t.nombre).length
        const totalVal = leads.filter(l => l.responsable === t.nombre && l.stage !== 'cancelado' && l.stage !== 'no_califica' && l.stage !== 'no_compro').reduce((s, l) => s + (l.totalVenta || 0), 0)
        const totalM2M = leads.filter(l => l.responsable === t.nombre && l.stage !== 'cancelado' && l.stage !== 'no_califica' && l.stage !== 'no_compro').reduce((s, l) => s + (l.commission70 || 0), 0)
        const esc = window.escHtml
        return `<div class="team-card" draggable="true" data-team-idx="${i}">
            <div class="team-drag-handle" title="Arrastrar para reordenar">☰</div>
            <div class="team-header">
                <div class="team-avatar">${esc(t.nombre.charAt(0))}</div>
                <div><div class="team-name">${esc(t.nombre)}</div><div class="team-role">${esc(t.rol || 'Sin rol')}</div>${t.email ? `<div class="team-email">${esc(t.email)}</div>` : ''}</div>
            </div>
            <div class="team-stats">
                <div class="team-stat"><div class="team-stat-val">${leadsCount}</div><div class="team-stat-label">Leads</div></div>
                <div class="team-stat"><div class="team-stat-val">${window.fmt(totalVal)}</div><div class="team-stat-label">Ventas</div></div>
                <div class="team-stat"><div class="team-stat-val">${window.fmt(totalM2M)}</div><div class="team-stat-label">M2M</div></div>
            </div>
            <div class="team-actions"><button class="btn btn-sm btn-secondary" onclick="editTeamMember('${t.id}')">Editar</button></div>
        </div>`
    }).join('')
    setupTeamDragDrop()
}

function setupTeamDragDrop() {
    let dragIdx = null
    document.querySelectorAll('.team-card[draggable]').forEach(card => {
        card.ondragstart = e => { dragIdx = parseInt(card.dataset.teamIdx); card.classList.add('dragging') }
        card.ondragend = () => { dragIdx = null; card.classList.remove('dragging'); document.querySelectorAll('.team-card').forEach(c => c.classList.remove('team-drag-over')) }
        card.ondragover = e => { e.preventDefault(); if (dragIdx !== parseInt(card.dataset.teamIdx)) card.classList.add('team-drag-over') }
        card.ondragleave = () => card.classList.remove('team-drag-over')
        card.ondrop = e => {
            e.preventDefault(); card.classList.remove('team-drag-over')
            const dropIdx = parseInt(card.dataset.teamIdx)
            if (dragIdx === null || dragIdx === dropIdx) return
            const { team } = store
            const [moved] = team.splice(dragIdx, 1)
            team.splice(dropIdx, 0, moved)
            team.forEach((t, i) => { t.orden = i + 1 })
            renderTeam()
            team.forEach(t => { if (t._supabaseId) window.supabaseDB.upsertTeamMember(t) })
        }
    })
}

// ========== DASHBOARD REACTIVO ==========

Object.assign(window, {
    populateSelects, populateMonthFilter, toggleOtroResp,
    updateBadges,
    renderPipeline, renderCard, getFilteredLeads,
    applyFilters, resetFilters,
    toggleHistorico, toggleModoCompleto, togglePanelDetails,
    syncEndDate, calcularAbono,
    updateStats, setupDragDrop, setupTeamDragDrop,
    handleSearch,
    renderClients, renderFrecuentes, renderM2M,
    renderProximos, renderHistorico, renderWatched, renderTeam,
})
